import React from 'react'

const TextInput = React.forwardRef((props, ref) => (
  <div className='template-field'>
    <input className='template-control' {...props} ref={ref} />
    {props.error && <div className='error_container'>{props.error}</div>}
  </div>
))

export default TextInput
